import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import template from './view-template.pug';
import { getBidMultiplierView } from '../single-multiplier-view/view';

export const getDeviceTypeMultipliersView = ({
  i18n, state, pageContext, multiplierSchema,
}) => {
  const { bidMultiplierUtils } = getHotelCenterUtils({ i18n, state });
  const { BidMultiplierView } = getBidMultiplierView({ i18n, pageContext, multiplierSchema });

  const { serializeBidMultipliers } = bidMultiplierUtils;

  /**
   * Shared view for Hotel Ads bid strategy setup section
   * @extends DeterministicView
   */

  const deviceTypeMap = {
    Mobile: 'HotelCenter_Overview_Multipliers_Bids_Mobile_Label',
    Tablet: 'HotelCenter_Overview_Multipliers_Bids_Tablet_Label',
    Desktop: 'HotelCenter_Overview_Multipliers_Bids_Desktop_Label',
  };

  class DeviceTypeMultipliersView extends DeterministicView {
    initialize(options) {
      this.listOfTypes = options.listOfTypes || deviceTypeMap;
      this.type = options.type || 'deviceType';

      _.each(this.listOfTypes, (i18nKey, type) => {
        this.setChild(`${type.toLowerCase()}-bid-multiplier`, this.getBidMultiplierView({
          value: type,
          text: i18n.getString(i18nKey),
        }));
      });
    }

    getBidMultiplierView(options) {
      const view = new BidMultiplierView({
        type: this.type,
        value: options.value,
        text: options.text,
      });

      return view;
    }

    get template() {
      return template;
    }

    getState() {
      const deviceMultipliersState = [];

      _.each(_.keys(this.listOfTypes), (key) => {
        deviceMultipliersState.push(this.getChild(`${key.toLowerCase()}-bid-multiplier`).getState());
      });

      if (_.findWhere(deviceMultipliersState, { isValid: false })) {
        return {
          isValid: false,
          bidMultipliers: _.noop(),
        };
      }

      return {
        isValid: true,
        bidMultipliers: serializeBidMultipliers(deviceMultipliersState),
      };
    }

    setState(options = {}) {
      const { isUseParent } = options;

      if (!_.isUndefined(isUseParent)) {
        _.each(_.keys(this.listOfTypes), (key) => {
          this.getChild(`${key.toLowerCase()}-bid-multiplier`).setState({ isUseParent });
        });
      }

      _.each(_.keys(this.listOfTypes), (key) => {
        if (options &&
          options[key] &&
          (options[key].strategy || !_.isUndefined(options[key].factor))) {
          this.getChild(`${key.toLowerCase()}-bid-multiplier`).setState({
            strategy: options[key].strategy,
            factor: options[key].factor,
          });
        }
      });

      return this;
    }
  }

  return {
    DeviceTypeMultipliersView,
  };
};
